import * as React from 'react';

import {MODAL_TWO_FA_RESEND_NOTICE} from '~/rootStore/modals/modalsIds';
import useModalById from '~/customHooks/useModalById';
import {VerificationMethods} from '~/modules/Auth/TwoFactorAuth/constants';

import ModalBaseContent from '../ModalBaseContent';
import ModalBase from '../ModalBase';
import image from './img/allow-location-icon.svg';

const ModalTwoFAResendNotice: React.FC = () => {
  const {
    isOpen,
    close: closeTwoFAResendNoticeModal,
    props: {verificationMethod},
  } = useModalById(MODAL_TWO_FA_RESEND_NOTICE);

  return (
    <ModalBase open={isOpen} onClose={closeTwoFAResendNoticeModal}>
      <ModalBaseContent
        p={2}
        image={image}
        title="No attempts left"
        description={`Sorry but all attempts have been exhausted. The new code was sent to your ${
          verificationMethod === VerificationMethods.email ? 'email' : 'phone number'
        }`}
        actionButtonText="OK"
        onClickActionButton={closeTwoFAResendNoticeModal}
      />
    </ModalBase>
  );
};

export default ModalTwoFAResendNotice;
